import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ref, onValue, update } from 'firebase/database';
import { db } from '../firebaseConfig';
import Navbar from '../components/Navbar';
import { useLanguage } from '../LanguageContext';

export default function NotificationsPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [user, setUser] = useState(null);
  const [pendingRequests, setPendingRequests] = useState([]);

  useEffect(() => {
    const savedUser = localStorage.getItem('guningo_user');
    if (!savedUser) {
      navigate('/');
      return;
    }
    setUser(JSON.parse(savedUser));
  }, [navigate]);

  useEffect(() => {
    if (!user || !user.name) return;
    const requestsRef = ref(db, 'bookingRequests/');
    const unsubscribe = onValue(requestsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data)
          .map(key => ({ id: key, ...data[key] }))
          .filter(r => r.driver === user.name && r.status === 'pending_approval');
        setPendingRequests(list);
      } else {
        setPendingRequests([]);
      }
    });
    return () => unsubscribe();
  }, [user]);

  const respondToRequest = async (requestId, approve) => {
    try {
      await update(ref(db, 'bookingRequests/' + requestId), {
        status: approve ? 'approved' : 'rejected',
        respondedAt: new Date().toISOString(),
      });
      alert(approve ? 'Approved! Passenger can now pay.' : 'Request declined.');
    } catch (error) {
      alert('Error: ' + error.message);
    }
  };

  if (!user) return null;

  return (
    <div style={styles.page}>
      <Navbar userName={user.name} userPhone={user.phone} />
      <div style={styles.container}>

        <h2 style={styles.pageTitle}>🔔 {t('notifications')}</h2>
        <p style={styles.pageSub}>{pendingRequests.length} unread</p>

        {pendingRequests.length === 0 ? (
          <div style={styles.emptyState}>
            <div style={{ fontSize: 40, marginBottom: 10 }}>🔔</div>
            <p style={{ color: '#9499b5' }}>No notifications yet</p>
          </div>
        ) : (
          <div>
            <p style={styles.dateLabel}>TODAY</p>
            {pendingRequests.map(r => (
              <div key={r.id} style={styles.notifCard}>
                <span style={{ fontSize: 20 }}>📨</span>
                <div style={{ flex: 1 }}>
                  <div style={styles.notifTitle}>New booking request</div>
                  <div style={styles.notifBody}>{r.passengerName} wants {r.seats} seat, {r.from} → {r.to}</div>
                  <div style={styles.actionRow}>
                    <button style={styles.approveBtn} onClick={() => respondToRequest(r.id, true)}>Approve</button>
                    <button style={styles.rejectBtn} onClick={() => respondToRequest(r.id, false)}>Reject</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#ffffff', fontFamily: 'Arial, sans-serif' },
  container: { maxWidth: 600, margin: '0 auto', padding: '30px 20px 40px' },
  pageTitle: { color: '#1a1a2e', margin: '0 0 4px' },
  pageSub: { color: '#9499b5', fontSize: 13, marginBottom: 20 },
  emptyState: { border: '1px solid #eef1f8', borderRadius: 14, padding: 40, textAlign: 'center' },
  dateLabel: { fontSize: 11, fontWeight: 700, color: '#9499b5', marginBottom: 8 },
  notifCard: { display: 'flex', gap: 10, background: '#eaf5fc', border: '1px solid #d9edfa', borderRadius: 12, padding: 12, marginBottom: 10 },
  notifTitle: { fontWeight: 600, fontSize: 13, color: '#1a1a2e' },
  notifBody: { fontSize: 12, color: '#5a5f7d', marginTop: 2, marginBottom: 8 },
  actionRow: { display: 'flex', gap: 8 },
  approveBtn: { background: '#3a8fd0', color: '#fff', border: 'none', borderRadius: 6, padding: '5px 12px', fontSize: 11, fontWeight: 600, cursor: 'pointer' },
  rejectBtn: { background: '#fff', border: '1px solid #d9edfa', borderRadius: 6, padding: '5px 12px', fontSize: 11, fontWeight: 600, cursor: 'pointer' },
};